/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserVoucher
 */
export interface UserVoucher {
    /**
     * 
     * @type {number}
     * @memberof UserVoucher
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof UserVoucher
     */
    voucherId?: number;
    /**
     * 
     * @type {Date}
     * @memberof UserVoucher
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserVoucher
     */
    updatedAt?: Date;
}

export function UserVoucherFromJSON(json: any): UserVoucher {
    return UserVoucherFromJSONTyped(json, false);
}

export function UserVoucherFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserVoucher {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'voucherId': !exists(json, 'voucherId') ? undefined : json['voucherId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}

export function UserVoucherToJSON(value?: UserVoucher | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'voucherId': value.voucherId,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}


